Monitoring.Views ||= {}
class Monitoring.Views.RelatedUsersConnectorView extends Backbone.View
  template: JST["backbone/templates/monitoring/related_users_connector"]

  initialize: (relatedUsersConnector, availableUsers, availableUsersGroups) ->
    @relatedUsersConnector = relatedUsersConnector
    @availableUsers = availableUsers
    @availableUsersGroups = availableUsersGroups

  render: ->
    @$el.html(@template({
      selectedUsers: @relatedUsersConnector.user_ids,
      selectedUsersGroups: @relatedUsersConnector.users_group_ids,
      availableUsers: @availableUsers,
      availableUsersGroups: @availableUsersGroups
    }))
    @$el.find('#related_users_connectors').change(@onChange)

    return this

  onChange: (_event) =>
    userIds = []
    usersGroupIds = []
    _.each @$el.find('#related_users_connectors').val(), (item) =>
      if item.startsWith('user_id-')
        userIds.push(parseInt(item.replace('user_id-', '')))
      else
        usersGroupIds.push(parseInt(item.replace('users_group_id-', '')))
    @trigger('onChange', { user_ids: userIds, users_group_ids: usersGroupIds })